import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import ErrorLoadingImage from '@atlassian/jira-illustrations/src/assets/error-loading-file.svg';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const SizeLimitErrorWithNoCTA = () => {
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			imageUrl={ErrorLoadingImage}
			header={formatMessage(messages.header)}
			description={formatMessage(messages.description)}
		/>
	);
};
